<template>
  <v-layout row wrap>
    <v-flex sm12 md12 xs12>
      <v-text-field
        placeholder="コメント"
        @click="inputClick($event)"
        :value="value"
        @input="
          isFocus = true
          $emit('input', $event)
        "
        @keydown="keydown($event)"
      >
      </v-text-field>
    </v-flex>
    <v-flex
      sm12
      md12
      xs12
      style="position: static; margin-top: -13px"
      v-show="isFocus"
    >
      <div
        class="select"
        style="
          position: absolute;
          background-color: white;

          z-index: 1999;
          padding: 3px 0px;
        "
      >
        <span
          v-for="(item, index) in displayItems"
          :key="index"
          @click="spanClick($event, item)"
          >{{ item }}</span
        >
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: ['value', 'items'],
  data() {
    return {
      isFocus: false,
      randomId: null,
    }
  },
  computed: {
    displayItems() {
      console.log('before items,', this.value, this.items)
      return this.items.filter(
        (i) => i.toUpperCase().indexOf((this.value || '').toUpperCase()) !== -1
      )
    },
  },
  methods: {
    inputClick(event) {
      document.body.click()
      event.stopPropagation()
      event.preventDefault()
      this.isFocus = true
    },
    spanClick(event, comment) {
      event.stopPropagation()
      event.preventDefault()
      this.isFocus = false
      this.$emit('input', comment)
    },
    keydown(event) {
      if (event.which === 9) {
        this.isFocus = false
      }
    },

    outerClick() {
      this.isFocus = false
    },
  },
  mounted() {
    document.addEventListener('click', this.outerClick)
  },
}
</script>
<style scoped>
.select span {
  display: block;
  margin: 5px 0px;
  padding: 5px;
}

.select span:hover {
  display: block;
  margin: 5px 0px;
  padding: 5px;
  background-color: yellow;
  cursor: pointer;
}
</style>
